module.exports = __webpack_public_path__ + "static/media/icn_start_date_1.6b297313.svg";